/** Dialog wrapper for creating a new task. */

import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/frontend/components/ui/dialog'
import { TaskForm } from '@/frontend/features/tasks/forms/task-form'

interface NewTaskDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  /** Pre-select a patient when opening from a patient context. */
  defaultPatientId?: string
  /** Optional label shown after "New Task" in the dialog title (e.g. patient name). */
  subtitle?: string
}

export function NewTaskDialog({
  open,
  onOpenChange,
  defaultPatientId,
  subtitle,
}: NewTaskDialogProps) {
  const defaultValues = defaultPatientId ? { patientId: defaultPatientId } : undefined

  // Outside-click dismissal is disabled to avoid losing entered task details.
  return (
    <Dialog open={open} onOpenChange={onOpenChange} disablePointerDismissal>
      <DialogContent className="max-h-[85vh] overflow-y-auto overflow-x-hidden">
        <DialogHeader>
          <DialogTitle>{subtitle ? `New Task — ${subtitle}` : 'New Task'}</DialogTitle>
        </DialogHeader>
        <TaskForm
          defaultValues={defaultValues}
          onSuccess={() => onOpenChange(false)}
          onCancel={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  )
}
